export default __webpack_public_path__ + "static/media/UserImg1.8c801102.png";